import { useState, useEffect } from 'react';
import DropDown from '../components/DropDown';
import Scanner from '../components/Scanner';
import API_ROOT from '../config';
import { PrimaryButton, SecondaryButton } from '../components/Button';
import LicenseData from '../components/LicenseData';
import { useFetch } from './Launchpad';

function Renew({ tenant, onDone }) {
    const [slot, setSlot] = useState('');
    const [notes, setNotes] = useState('');
    const [location, setLocation] = useState('');
    const [qrCode, setQrCode] = useState('');
    const [licenseData, setLicenseData] = useState(null);
    const [error, setError] = useState('');
    const [slots, setSlots] = useState(undefined);
    const { fetchWithAuth } = useFetch();
    const renew = async () => {
        const options = {
            method: 'POST',
            body: JSON.stringify(
                {
                    action: "renew",
                    identifier: slot,
                    request_base64: qrCode,
                    delay: 0,
                    developer: false,
                    additional_parameters: [
                        `Notes=${notes}`,
                        `Location=${location}`
                    ]
                }
            )
        };

        const response = await fetchWithAuth(`${API_ROOT}/v1/license/${tenant}`, options);
        if (!response.ok) {
            let errorText = await response.text();
            const errorPrefix = 'Unable to renew license: ';
            try {
                let errorData = JSON.parse(errorText);
                setError(errorPrefix + (errorData.Message ?? ""));
            }
            catch (e) {
                setError(errorPrefix + errorText);
            }
            console.error(errorPrefix, response);
            return;
        }
        if (response.status === 208) {
            setError('Cabinet already renewed');
            return;
        }
        const key = await response.json();
        setLicenseData(key);
    }



    // Fetch slots when the component mounts or tenant changes
    useEffect(() => {
        const getSlots = async () => {
            try {
                const url = `${API_ROOT}/slots/${tenant}`;
                const response = await fetchWithAuth(url);
                
                if (response.status === 204) {
                    setSlots([]);
                    return;
                }
                
                if (!response.ok) {
                    setSlots([]);
                    setError('An error occurred while fetching available licenses: ' + response.statusText);
                    return;
                }

                const data = await response.json();
                setSlots(data);
            } catch (error) {
                console.error('Error fetching:', error);
            }
        };

        if (tenant) {
            getSlots();
        }
    }, [tenant]);



    const clear = () => {
        setQrCode('');
        setLicenseData(null);
        setError('');
    }

    const canRenew = tenant && slot && qrCode;

    if (slots === undefined) {
        return <div>Loading...</div>;
    }

    if (slots.length === 0) {
        return <div>
            <div>No licenses available for this tenant</div>
            <SecondaryButton onClick={onDone}>Back</SecondaryButton>
        </div>;
    }

    return (
        <div>
            {qrCode ? 'Code scanned successfully' : <div>
                Set the cabinet to audit mode and scan the QR code to renew it.
                <Scanner onScan={setQrCode} />
            </div>}

            {tenant && <DropDown
                placeholder="Select a license type"
                options={slots}
                value={slot}
                disabled={!!licenseData}
                idProperty='identifier'
                onChange={setSlot} />
            }
            <input
                disabled={!!licenseData}
                type="text"
                className="form-control my-2"
                placeholder="Location"
                value={location}
                onChange={e => setLocation(e.target.value)}
            />

            <textarea
                disabled={!!licenseData}
                className="form-control my-2"
                placeholder="Notes"
                value={notes}
                onChange={e => setNotes(e.target.value)}
            />


            {!(error || licenseData) && <PrimaryButton disabled={!canRenew} onClick={renew}>Renew</PrimaryButton>}
            {licenseData && <div><LicenseData data={licenseData} /></div>}

            {(error || licenseData) && <SecondaryButton onClick={clear}>Renew another cabinet</SecondaryButton>}
            <SecondaryButton onClick={onDone}>{licenseData ? "Done" : "Cancel"}</SecondaryButton>

            {error && <div className="alert alert-danger mt-2">{error}</div>}
        </div>
    );
}

export default Renew;